export default {
  // 报图介绍部分，使用drawingsNotice中的重复词汇
  check_drawings_apply: "审图申请",
  add_application: "新增申请",
  report_drawings_introduce: "报图介绍",
  application_records: "申请记录",
  check_status: "审图状态",
  btn_modify: "修改",
  btn_continue: "继续",
  btn_cancel_submit: "撤销提交",
  btn_cancel: "取消申请",
  producer: "搭建公司",
  exhibitor: "参展商",
  apply_date: "创建时间",
  initial_reporting_time: "初次报图时间",
  last_update_time: "最后更新时间",
  get_detail: "查看",
  nothing: "暂无内容",
  操作: "操作",
  no_application: "暂无申请记录",
  // SUBMITTED: '待提交',
  // PENDING: '待审核',
  // VERIFIED: '审核通过',
  // REJECTED: '未通过',
  // CANCELED: '已取消',
  // DISABLED: '已失效',
  cancel_tips_title: "撤销确认",
  cancel_tips_content:
    "您正在撤销当前展位报图申请，撤销后填写的报图资料将不被保存，您将只能重新提交。是否确定执行撤销操作?",
  cancel_success: "取消成功",
  cancel_fail: "取消失败，请稍后再试！",
  net_error: "网络出现了一点小问题，请稍后再试^_-",
  编辑资料: "编辑资料",
  修改现场人员:'修改现场人员',
  下载审图回执: "下载审图回执",
  更多: "更多",
  关闭: "关闭",
  确认取消: "确认取消"
};



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/drawings/drawingsIndex.js